// The client side of /api/experiments (BUILD-BRIEF-R2 §10) — owned by the `journeys` agent.
import { request } from './client.js';
import type { Experiment, ExperimentReport, ExperimentVariable, ListResponse } from '../../shared/types.js';

/** The report as the wire carries it: the shared shape plus the threshold it was judged by. */
export interface AttributionReport extends ExperimentReport {
  min_n: number;
}

export function listExperiments(): Promise<ListResponse<Experiment>> {
  return request('/experiments');
}

export function createExperiment(input: {
  name: string; variable: ExperimentVariable; variants: Experiment['variants']; sequence_id?: number | null;
}): Promise<Experiment> {
  return request('/experiments', { method: 'POST', body: JSON.stringify(input) });
}

export function endExperiment(id: number): Promise<Experiment> {
  return request(`/experiments/${id}/end`, { method: 'POST' });
}

/** `reply_rate` is null below n = 20 and the page says "too few to say" — never a percentage
 *  computed from four sends. */
export function report(id: number): Promise<AttributionReport> {
  return request(`/experiments/${id}/report`);
}
